module.exports = __webpack_public_path__ + "static/media/orders_cart.a20f72b3.svg";